module.exports = __webpack_public_path__ + "img/12.998fc1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/12.jpg
// module id = 204
// module chunks = 1